import React from "react"

export default function Header() {
  return (
    <div>
      <h1>Popsticles</h1>
    </div>
  );
}